// src/lib/onboarding/onboardingGuard.js
// Pure guard function — no side effects, fully testable.
// Called by App.jsx before rendering any authenticated route.

/**
 * Determines whether a user may proceed to the app or must be
 * redirected to onboarding.
 *
 * @param {import("./onboardingTypes").OnboardingStatus | "loading"} status
 * @returns {"allow" | "redirect" | "loading"}
 */
export function onboardingGuard(status) {
  // Still fetching — don't redirect yet, show loading state
  if (status === "loading") return "loading";

  // Onboarding complete — let the user through
  if (status === "complete") return "allow";

  // pending or in_progress — redirect to onboarding
  return "redirect";
}
